const counters = document.querySelectorAll(".counter-number");

const runCounter = (counter) => {
  const symbol = counter.dataset.symbol || "";
  const target = +counter.dataset.target;
  let count = 0;
  const increment = target / 200;

  const updateCounter = () => {
    if (count < target) {
      count += increment;
      counter.innerText = Math.ceil(count) + symbol;
      requestAnimationFrame(updateCounter);
    } else {
      counter.innerText = target + symbol;
    }
  };

  updateCounter();
};


// Intersection Observer
const observer = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const counter = entry.target;

        // Prevent re-running
        if (!counter.classList.contains("counted")) {
          counter.classList.add("counted");
          runCounter(counter);
        }

        observer.unobserve(counter);
      }
    });
  },
  {
    threshold: 0.5 // 50% visible
  }
);


// Observe all counters
counters.forEach(counter => observer.observe(counter));
